/**
 * Returns 'count' array of numbers from interval
 * minVal and maxVal indexes are included.
 * 
 * @param minVal 
 * @param maxVal 
 * @param count 
 * @returns 
 */
export function GetUniqueNumbersFromInterval(minVal: number, maxVal: number, count: number): number[]
{
    count = Math.min(maxVal - minVal, count);
    let numbers = [];
    while (numbers.length < count) {
        const randomNumber = minVal + Math.floor(Math.random() * maxVal);
        if (!numbers.includes(randomNumber)) {
            numbers.push(randomNumber);
        }
    }
    return numbers;
 }